module.exports = __webpack_public_path__ + "media/images/home/icon-facebook-9e3115e6b097da79b9623a54c321a574.svg";